import { render, staticRenderFns } from "./SyncModal.vue?vue&type=template&id=dfe85578&scoped=true"
import script from "./SyncModal.vue?vue&type=script&lang=js"
export * from "./SyncModal.vue?vue&type=script&lang=js"
import style0 from "./SyncModal.vue?vue&type=style&index=0&id=dfe85578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe85578",
  null
  
)

export default component.exports